new ScrollReveal().reveal('.card-module', {
        delay: 0,
        duration: 1000,
        distance: '150px',
        reset: false
});
